import React from "react";
import { Row, Col, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Pricelists from "./pricelists";

const Contract = () => (
  <Row>
    <Col>
      <Typography.Paragraph>
        <FormattedMessage
          id="contracts.contract.no"
          defaultMessage="Žádná smlouva není dostupná."
        />
      </Typography.Paragraph>
    </Col>
    <Pricelists />
  </Row>
);

export default Contract;
